import { composeIO } from 'react-compose-io'
import { modalChamadosIO } from './ModalChamados.IO'
import ModalChamadosView from './ModalChamados.View'

export const ModalChamados = composeIO(ModalChamadosView, modalChamadosIO)
